/*
* 更改state
* mutation必须是同步函数，不支持异步，异步请使用actions
* 触发方式: store.commit('name')
*/
import * as types from './mutation-types'
export default {
  [types.setMessage] (state, message) {
    state.message = message
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js